import { render, staticRenderFns } from "./CouncilsTable.vue?vue&type=template&id=0e343c2b&"
import script from "./CouncilsTable.vue?vue&type=script&lang=js&"
export * from "./CouncilsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports